import { useMemo } from 'react';

import usePageLayout from '@/components/layout/usePageLayout';

import '@/playlist/games/common/styles/game-layout.scss';

const useGameLayout = (layoutClassName?: string) => {
	const pageLayoutConfig = useMemo(
		() => ({
			hideHeader: true,
			layoutProps: layoutClassName ? { className: layoutClassName } : undefined,
			mainProps: {
				className: 'game-layout-main',
			},
		}),
		[layoutClassName],
	);

	usePageLayout(pageLayoutConfig, [pageLayoutConfig]);
};

export default useGameLayout;
